import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useState } from "react";
import { HoverPopoverProps } from ".";



export function HoverPopover({ 
    children, 
    content, 
    onHover = false, 
    open: controlledOpen,
    popoverContentProps,
    onOpenChange 
}: Readonly<HoverPopoverProps>) {
    const [internalOpen, setInternalOpen] = useState(false);
    
    const isControlled = controlledOpen !== undefined;
    const isOpen = isControlled ? controlledOpen : internalOpen;
    
    const handleOpenChange = (open: boolean) => {
        if (isControlled) {
            onOpenChange?.(open);
        } else {
            setInternalOpen(open);
        }
    };

    const triggerProps = onHover ? {
        onMouseEnter: () => handleOpenChange(true),
        onMouseLeave: () => handleOpenChange(false)
    } : {};
    return (
        <Popover open={isOpen} onOpenChange={handleOpenChange}>
            <PopoverTrigger {...triggerProps}>
                {children}
            </PopoverTrigger>
            <PopoverContent {...popoverContentProps}>
                {content}
            </PopoverContent>
        </Popover>
    );
}


